import { globalEnv } from "~/global-env";
import { GetPositionsQuery } from "~/graphql/supergraphTypes";
import { getPositionRiskRating } from "../../riskRating/utils";
import { isFatcaCrsProfile } from "../PaymentInstructions/utils";
import { PositionRowItem } from "./types";

export const rowsFromQuery = (data: GetPositionsQuery): PositionRowItem[] => {
  if (!data.casePositionDetails) return [];

  const fatcaCrsProfileIds = new Set(
    (data.complianceCase?.profiles ?? [])
      .filter((p) => p && isFatcaCrsProfile(p))
      .map((p) => p?.id),
  );

  return data.casePositionDetails.map((position) => {
    const currentRatingInfo = position.riskRatings?.current;
    const proposedRatingInfo = position.riskRatings?.proposed;

    const currentRating = getPositionRiskRating(
      currentRatingInfo?.investor,
      currentRatingInfo?.paymentBeneficiary,
      currentRatingInfo?.bankAccountDomicile,
    );
    const proposedRating = getPositionRiskRating(
      proposedRatingInfo?.investor,
      proposedRatingInfo?.paymentBeneficiary,
      proposedRatingInfo?.bankAccountDomicile,
    );

    return {
      id: position.caseId?.toString() ?? "",
      position: {
        accountName: position.rootProfileName ?? null,
        entityName: position.entityName ?? null,
      },
      affectedProfiles: (position.affectedProfiles ?? []).filter(
        (p) => !fatcaCrsProfileIds.has(p.profileId),
      ),
      client: position.clientName ?? null,
      program: position.programName ?? null,
      riskRatingInfo: {
        currentRating: currentRating,
        proposedRating: proposedRating,
        currentRatingInfo: {
          investor: currentRatingInfo?.investor ?? null,
          beneficiary: currentRatingInfo?.paymentBeneficiary ?? null,
          bankAccount: currentRatingInfo?.bankAccountDomicile ?? null,
        },
        proposedRatingInfo: {
          investor: proposedRatingInfo?.investor ?? null,
          beneficiary: proposedRatingInfo?.paymentBeneficiary ?? null,
          bankAccount: proposedRatingInfo?.bankAccountDomicile ?? null,
        },
      },
      positionId: null,
      arenaId: null,
      entityId: null,
    };
  });
};

export const buildViewAllPositionsHref = (rows: PositionRowItem[]): string => {
  const positionIds = [
    ...new Set(rows.map((row) => row.positionId).filter((id): id is number => id != null)),
  ];
  const arenaIds = [
    ...new Set(rows.map((row) => row.arenaId).filter((id): id is number => id != null)),
  ];

  const base = `/canopy${globalEnv.complianceRoute}/positions`;
  const params = new URLSearchParams();
  if (arenaIds.length > 0) params.set("arenaIds", arenaIds.join(","));
  if (positionIds.length > 0) params.set("positionIds", positionIds.join(","));

  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
};
